import { post, patch, get, deleted } from "services";
import routes from "./routes";

const ReconcileServices = {
  createReconcile: async (obj) => {
    const data = await post(routes.createReconcile, obj);
    return data;
  },
  submitReconcile: async (obj) => {
    const data = await patch(routes.submitReconcile, obj);
    return data;
  },
  updateReconcile: async (obj) => {
    const data = await patch(routes.updateReconcile, obj);
    return data;
  },

  getReconcileList: async (params) => {
    const data = await get(routes.getReconcileList, params);
    return data;
  },
  getReconcileApproval: async (params) => {
    const data = await patch(routes.getReconcileApproval, params);
    return data;
  },
  getReconcileDetail: async (params) => {
    const data = await get(
      `${routes.getReconcileDetail}/${params.reconcile_id}`,
      params
    );
    return data;
  },
  deleteReconcile: async (obj) => {
    const data = await patch(routes.deleteReconcile, obj);
    return data;
  },
  deleteReconcileStatement: async (obj) => {
    const data = await patch(routes.deleteReconcileStatement, obj);
    return data;
  },
  getVerifiedReports: async (params) => {
    const data = await get(routes.getVerifiedReports, params);
    return data;
  },
  uploadReport: async (params) => {
    const data = await post(routes.uploadReport, params);
    return data;
  },
  deleteReport: async (params) => {
    const data = await deleted(routes.deleteReport, params);
    return data;
  },
};

export default ReconcileServices;
